import api from '../../containers/api';
const baseUrl = "http://139.255.24.122/medapp-v2/public/medapp/api/v1/doctor/list"

export const getDocter = () => {
    return (dispatch) => {
        api.create().getListDokter().then(response => {
            if (response.data) {
                let listDokter = response.data.data.sort((a, b) => a.id - b.id)
                console.log(listDokter);
                dispatch({
                    type: 'GET_DOKTER',
                    payload: {
                        dokter: listDokter
                    }
                })
                // if (response.data.status === true) {
                //     if (response.data.data.length > 0) {
                //         this.setState({
                //             listDokter: response.data.data.sort((a, b) => a.id - b.id),
                //             loading: false
                //         })
                //     } else {
                //         this.setState({ listDokter: [], loading: false })
                //     }
                // }
            }
        })
    }
}

export const addDocter = (newDocter) => {
    console.log(newDocter);
    const {
        kodeDokter,
        spesialisDokter,
        alamat,
        durasiPeriksa,
        namaDokter,
        poliklinik,
        pengalamanDokter,
    } = newDocter
    let payload = {
        dr_code: kodeDokter,
        speciality_id: spesialisDokter,
        polyclinic_id: poliklinik,
        name: namaDokter,
        address: alamat
    }
    return (dispatch) => {
        api.create().createDokter(payload).then(response => {
            if (response) {
                console.log(response, 'yes');
                // dispatch({
                    
                //     }
                // }) 
            }
        })
        .catch(err => {
            console.log(err);
        })
    }
}